import addressbook from './second-level/addressbook';
import events from './second-level/events';
import settings from './second-level/settings';

export default [
    {
        key: 'root.events',
        icon: 'calendar-alt',
        right: 'guestlists::list',
        type: 'placeholder',
        tooltip: 'Events',
        children: events
    },
    {
        key: 'root.addressbook',
        icon: 'address-book',
        type: 'placeholder',
        right: 'addressbook::list',
        tooltip: 'Addressbook',
        children: addressbook
    },
    {
        key: 'root.settings',
        icon: 'cogs',
        type: 'placeholder',
        showInNavigation: false,
        tooltip: 'Settings',
        children: settings
    }
];



// WEBPACK FOOTER //
// ./src/app/modules/navigation/resources/nav-structure.js